import TemplateTagPicker from "./TemplateTagPicker";

export default TemplateTagPicker;
